import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconParking24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="parking">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.1314 5.48571C15.9429 4.49524 14.3124 4 12.24 4H6V20H8.28571V15.1543H12.24C14.3124 15.1543 15.9429 14.659 17.1314 13.6686C18.32 12.6781 18.9143 11.3143 18.9143 9.57714C18.9143 7.84 18.32 6.47619 17.1314 5.48571ZM15.4857 12.2514C14.7238 12.861 13.619 13.1657 12.1714 13.1657H8.28571V5.98857H12.1714C13.619 5.98857 14.7238 6.30095 15.4857 6.92571C16.2476 7.53524 16.6286 8.41905 16.6286 9.57714C16.6286 10.7352 16.2476 11.6267 15.4857 12.2514Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4ZM4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4C2 2.89543 2.89543 2 4 2Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
